import { isEmpty } from "lodash-es";
import { useCallback } from "react";
import useSWR from "swr";
import { fetchTokenTradePair } from "~/api/endpoints";
import { useSnackbar } from "~/Provider/Snackbar";
import { useUXUYWallet } from "~/Provider/UXUYWallet";

const useQueryTradePairAndBalance = (chain_id: string, contract: string) => {
    const { getAddress, getAddressType } = useUXUYWallet();
    const snackbar = useSnackbar();

    const address = getAddress(chain_id);
    const addressType = getAddressType(chain_id);

    const queryTokenTradePair = useCallback(
        async ([, chainId, contract, address, address_type]: any) => {
            if (isEmpty(chainId)) return;
            if (isEmpty(contract)) return;
            if (isEmpty(address)) return;

            try {
                const data = await fetchTokenTradePair({
                    chain_id: chainId,
                    contract,
                    address,
                    address_type,
                });
                return data.data;
            } catch (err: any) {
                if ("code" in err) {
                    snackbar.error(err.message);
                    throw err;
                }

                snackbar.error(
                    `Can not load token info! Check your network connection!`
                );
                throw err;
            }
        },
        [snackbar]
    );

    return useSWR(
        [
            "QuickBuyPage:queryTokenTradePair",
            chain_id,
            contract,
            address,
            addressType,
        ],
        queryTokenTradePair
    );
};

export default useQueryTradePairAndBalance;
